import { hasGate, hasScope } from 'personalization-lib/utils/auth/userPermissions';
import { FEATURE_GATES } from 'personalization-lib/constants/auth';
export const getFeatureGates = () => ({
  webVisitors: hasGate(FEATURE_GATES.webVisitors),
  websitePages: hasGate(FEATURE_GATES.websitePages),
  createVariantInEditor: hasGate(FEATURE_GATES.createVariantInEditor),
  ctaV2Editor: hasGate(FEATURE_GATES.ctaV2Editor)
});
export const getPersonalizationAccess = () => ({
  view: hasScope('personalize-view'),
  edit: hasScope('personalize-edit')
});